import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
// import actions from './action'
// import getters from './getter'

Vue.use(Vuex)

const state = {
    recent: [],
    url: location.origin.indexOf('localhost')>-1 ? 'https://myzonghe.cryptovipss.com/' : location.origin + '/',
    token: "", //用户标识
    user: "", //用户信息
    userdetail: "",
    policydetail: "",
    s_history: [], //搜索记录
    config: "",
    download_url: "l",
    chat_url: ""
}


export default new Vuex.Store({
    state,
    mutations,
})


// WEBPACK FOOTER //
// ./src/store/index.js